export const SEND_REQUEST_TIMEOUT = "SEND_REQUEST_TIMEOUT" as const;

/** Result type for connectionContext.sendRequest. Use with `if (!res.ok)` then access `res.error`. */
export type SendRequestResult = { ok: true; data: string } | { ok: false; error: Error };

/** Returns the error when result is not ok; use for type-safe handling of sendRequest result. */
export function getSendRequestError(res: SendRequestResult): Error | null {
  if ("error" in res) return res.error;
  return null;
}

export class SendRequestTimeoutError extends Error {
  readonly code = SEND_REQUEST_TIMEOUT;

  constructor() {
    super("The wallet app did not respond in time.");
    this.name = "SendRequestTimeoutError";
    Object.setPrototypeOf(this, SendRequestTimeoutError.prototype);
  }
}

export function getSendRequestErrorMessage(error: Error): string {
  return error instanceof SendRequestTimeoutError
    ? "The wallet app did not respond in time."
    : "Something went wrong.";
}
